import { ScrollText } from 'lucide-react'
import { Link } from 'react-router-dom'

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-secondary-500 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <ScrollText className="h-12 w-12 mx-auto mb-4 text-primary-400" />
          <h1 className="text-3xl md:text-5xl font-bold mb-4">Terms and Conditions</h1>
          <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto">
            Please read these booking terms carefully before reserving your stay
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white p-8 md:p-12 rounded-xl shadow-sm text-gray-700 space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                <span className="bg-primary-100 text-primary-600 rounded-full w-8 h-8 flex items-center justify-center text-sm">1</span>
                Booking Confirmation
              </h2>
              <p className="ml-10">Your room booking is confirmed only upon receipt of an advance payment. We reserve the right to cancel unconfirmed bookings.</p>
            </div>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                <span className="bg-primary-100 text-primary-600 rounded-full w-8 h-8 flex items-center justify-center text-sm">2</span>
                Check-In & Check-Out Timings
              </h2>
              <p className="ml-10">Our standard check-in time is <strong className="text-gray-900">12:00 PM (Noon)</strong>, and check-out time is <strong className="text-gray-900">11:00 AM</strong>. Early check-in and late check-out requests are subject to availability and might incur additional charges.</p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                <span className="bg-primary-100 text-primary-600 rounded-full w-8 h-8 flex items-center justify-center text-sm">3</span>
                Guest Identification
              </h2>
              <p className="ml-10">All guests must present a valid, government-issued photo ID upon check-in. Indian nationals must provide a valid <strong className="text-gray-900">Aadhar Card</strong>. The primary guest must be at least 18 years old.</p>
            </div>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                <span className="bg-primary-100 text-primary-600 rounded-full w-8 h-8 flex items-center justify-center text-sm">4</span>
                Room Occupancy & Pricing
              </h2>
              <p className="ml-10">Prices are specific to room types. Standard Room (<strong className="text-gray-900">₹999/night</strong>) accommodates 2 adults. Deluxe Room (<strong className="text-gray-900">₹1,499/night</strong>) accommodates 2 adults and 1 child. Extra guests may incur additional charges.</p>
            </div>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                <span className="bg-primary-100 text-primary-600 rounded-full w-8 h-8 flex items-center justify-center text-sm">5</span>
                Guest Behavior
              </h2>
              <p className="ml-10">We kindly ask all guests to respect the comfort of others. Excessive noise, property damage, or illegal activities will result in immediate cancellation of your stay without a refund. Aonla Stay reserves the right to refuse service to anyone who violates our policies.</p>
            </div>
            
            <div className="pt-6 border-t mt-8">
              <Link to="/rooms" className="inline-block px-8 py-3 bg-primary-500 text-white font-semibold rounded-lg shadow hover:bg-primary-600 transition-colors">
                Accept & Book Now
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Terms
